export default {
    'InsertUnameEmail':     'Benutzernamen oder E-Mail eingeben',
    'ChangePass':           'Passwort ändern',
    'UnameOrEmail':         'Benutzername oder E-Mail',
    'PassRecover':          'Passwort wiederherstellen',
    'InsertCurrPass':       'Aktuelles Passwort eingeben',
    'CurrentPass':          'Aktuelles Passwort',
    'NewPass':              'Neues Passwort',
    'CreateNewPass':        'Neues Passwort erstellen',
    'ConfirmNewPass':       'Neues Passwort bestätigen',
    'show_pass':            'Passwort anzeigen',
    'hide_pass':            'Passwort verbergen',
    'RequiredField':        'Pflichtfeld',
    'PassDontMatch':        'Passwörter stimmen nicht überein',
    'PassReq1':             'Darf nicht zu gewöhnlich sein',
    'PassReq2':             'Muss mindestens 12 Zeichen enthalten',
    'PassReq3':             'Darf nicht nur Zahlen enthalten',
    'SuccessMailSent':      'Eine E-Mail wurde an die angegebene Adresse (oder den Benutzer) gesendet. Befolgen Sie die Anweisungen in der E-Mail, um Ihr Passwort zurückzusetzen',
    'SuccessMailSent2':     'Wenn Sie die Nachricht nicht innerhalb weniger Augenblicke erhalten, wenden Sie sich bitte an den Systemadministrator',
    'SuccessPassReset':     'Sie haben Ihr Passwort erfolgreich geändert',
    'Send':                 'Senden',
    'UnknownError':         'Unerwarteter Fehler, bitte versuchen Sie es erneut oder wenden Sie sich an den Systemadministrator.',
    'Language':             'Sprache'
}